import { IPaymentMethod } from "../models/IPaymentMethod";
import { configWithUserToken } from "./config";

export const getPaymentMethods = () =>
  configWithUserToken.get<IPaymentMethod[]>("PaymentMethod");

export const getRestaurantPaymentMethods = (restaurantId: string) =>
  configWithUserToken.get<IPaymentMethod[]>(`PaymentMethod/restaurant/${restaurantId}`);

export const assignPaymentMethod = (restaurantId: string, paymentMethodId: string) =>
  configWithUserToken.post(`PaymentMethod/restaurant/${restaurantId}/assign/${paymentMethodId}`, null);

export const removePaymentMethod = (restaurantId: string, paymentMethodId: string) =>
  configWithUserToken.delete(`PaymentMethod/restaurant/${restaurantId}/remove/${paymentMethodId}`);
